/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FunctionMaturityItem } from './FunctionMaturityItem';
import {
    FunctionMaturityItemFromJSON,
    FunctionMaturityItemFromJSONTyped,
    FunctionMaturityItemToJSON,
    FunctionMaturityItemToJSONTyped,
} from './FunctionMaturityItem';

/**
 * 
 * @export
 * @interface FunctionMaturityResponse
 */
export interface FunctionMaturityResponse {
    /**
     * 
     * @type {Array<FunctionMaturityItem>}
     * @memberof FunctionMaturityResponse
     */
    items?: Array<FunctionMaturityItem>;
}

/**
 * Check if a given object implements the FunctionMaturityResponse interface.
 */
export function instanceOfFunctionMaturityResponse(value: object): value is FunctionMaturityResponse {
    return true;
}

export function FunctionMaturityResponseFromJSON(json: any): FunctionMaturityResponse {
    return FunctionMaturityResponseFromJSONTyped(json, false);
}

export function FunctionMaturityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionMaturityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(FunctionMaturityItemFromJSON)),
    };
}

export function FunctionMaturityResponseToJSON(json: any): FunctionMaturityResponse {
    return FunctionMaturityResponseToJSONTyped(json, false);
}

export function FunctionMaturityResponseToJSONTyped(value?: FunctionMaturityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(FunctionMaturityItemToJSON)),
    };
}

